import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { CompanionSettingInitStepDeclaration } from "./Steps/CompanionSettingInitStep";

const companionSettingMainStartupFlow = new FlowDefinition("CompanionSettingFlow");

companionSettingMainStartupFlow.addStep(CompanionSettingInitStepDeclaration);

companionSettingMainStartupFlow.setStartStep("CompanionSettingInit_Step");

export const companionSettingStartupFlowDefinition = new StepDefinition({
    stepName: "CompanionSettingFlow",
    stepFlow: companionSettingMainStartupFlow,
    contextIsolation: false
})
